import { Box, Stack, styled } from '@mui/material';
import {
	AnimatePresence,
	AnimateSharedLayout,
	LayoutGroup,
	MotionProps,
} from 'framer-motion';
import { useFieldArray, useFormContext } from 'react-hook-form';
import MessageBox from './MessageBox';
import { FormValues } from './Widget';
import { motion } from 'framer-motion';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useEffect, useRef } from 'react';
import { Message } from '../types';

const MessagesContainer = styled(Box)(({ theme }) => ({
	flex: '1 1 auto',
	minHeight: 300,
	maxHeight: 300,
	overflow: 'auto',
	marginBottom: theme.spacing(2),
}));

interface Props {
	isLoading: boolean;
	messages: Message[];
}

export default function Messages({ isLoading, messages }: Props) {
	const scrollbarsRef = useRef<Scrollbars | null>(null);
	const { control } = useFormContext<FormValues>();

	const isEmptyMessages = messages.length === 1;

	const animations: (isRight?: boolean) => MotionProps = (isRight) => ({
		initial: {
			x: isEmptyMessages ? (isRight ? '20%' : '-20%') : 0,
			y: isEmptyMessages ? 0 : '100%',
			opacity: 0,
		},
		animate: {
			x: 0,
			y: 0,
			opacity: 1,
		},
		transition: {
			type: 'just',
		},
	});

	useEffect(() => {
		if (!scrollbarsRef.current) {
			return;
		}

		const scrollbars = scrollbarsRef.current as Scrollbars;
		const height = scrollbars.getScrollHeight();
		scrollbars.scrollTop(height);
	}, [messages]);

	return (
		<MessagesContainer>
			<Scrollbars
				height="100%"
				width="100%"
				renderThumbHorizontal={() => <div></div>}
				ref={scrollbarsRef}
			>
				<Stack spacing={1} mr={1.5}>
					<LayoutGroup>
						{messages.map((el) => (
							<motion.div layout {...animations(el.isRight)} key={el.id}>
								<MessageBox message={el} />
							</motion.div>
						))}
					</LayoutGroup>
				</Stack>
			</Scrollbars>
		</MessagesContainer>
	);
}
